/**
 * Tabs handling
 * handles tabs on big devices and selectbox on smaller devices
 *
 */
export default class Tabs {

    // constructor
    constructor(selector) {
        this.init(selector);
    }


    // init
    init(selector) {

        let vm = this;

        // plugin selector
        this.$plugin = $(selector);

        // if plugin does not exist, cancel
        if (this.$plugin.length === 0) {
            return false;
        }

        // active classes
        this.activePanelClass = 'active';
        this.activeContentClass = 'active';

        // jquery selectors
        this.$contentItems = $('[data-tncp-tabs-content]');
        this.$dropdownItemsId = $('[data-tncp-tabs-dropdown]');

        // load event handlers
        this.eventHandlers();

        // wait for eventlisteners, load tabs if dom ready
        if (window.addEventListener) {
            window.addEventListener('load', function() {
                vm.$plugin.attr('data-tncp-tabs-readystate', true);
                // set initial sate by url parameter
                if (window.tncpRouter.getRoute()) {
                    vm.changeTabs(window.tncpRouter.getRoute());
                } else {
                    window.tncpRouter.setRoute('0');
                    vm.changeTabs('0');
                }

            });
        }

    }


    /**
     * events to handle
     */
    eventHandlers() {
        let _this = this;

        // click on item
        $(document).on('click', '[data-tncp-tabs-panel-id]', function() {
            let $self = $(this);
            let contentId = String($self.data('tncp-tabs-panel-id'));
            _this.changeTabs(contentId);
        });

        // opens a tab by data-attribute
        // should contain the tabs-value like "0-1" or "1"
        // e.g. data-tncp-tabs-trigger-link="0-1"
        $(document).on('click', '[data-tncp-tabs-trigger-link]', function() {
            let $self = $(this);
            let contentId = String($self.data('tncp-tabs-trigger-link'));
            _this.changeTabs(contentId);
        });

        _this.$dropdownItemsId.change(function () {
            let $self = $(this);
            let contentId = String($self.find(':selected').data('tncp-tabs-panel-id'));
            _this.changeTabs(contentId);
        });
    }


    /**
     * changes the tabs for at least 2 levels
     *
     * @param tabIdsString
     */
    changeTabs(tabIdsString) {
        let vm = this;
        let tabIds = tabIdsString.split('-');

        // selected container of content-id
        let $selectedContainer = vm.$plugin.find('[data-tncp-tabs-content-id="' + tabIdsString +  '"]');

        // selected tab-level
        let selectedLvl = $selectedContainer.data('tncp-tabs-content-lvl');

        // if selected level is 0 (big tabs) && sub-tabs exists in selected container
        if (selectedLvl === 0 && $selectedContainer.find('[data-tncp-tabs-panel-lvl]').length > 0) {
            tabIds.push('0');
            window.tncpRouter.setRoute(tabIdsString + '-0', true);
        } else {
            window.tncpRouter.setRoute(tabIdsString, true);
        }

        _.forEach(tabIds, function(value, index) {
            // only use first part for routing. Needed if tab and filter are given in url (powerview of examination cockpit)
            value = value.split("/")[0];

            // first iteration (big tabs)
            if (index === 0) {

                vm.$plugin.find('[data-tncp-tabs-panel-lvl="' + index +  '"]').removeClass(vm.activePanelClass);
                vm.$plugin.find('[data-tncp-tabs-panel-lvl="' + index +  '"][data-tncp-tabs-panel-id="' + value +  '"]').addClass(vm.activePanelClass);
                $(vm.$plugin.find('[data-tncp-tabs-dropdown]')[0]).prop('selectedIndex', value);
                vm.$plugin.find('[data-tncp-tabs-content-lvl="' + index +  '"]').removeClass(vm.activeContentClass);
                vm.$plugin.find('[data-tncp-tabs-content-lvl="' + index +  '"][data-tncp-tabs-content-id="' + value +  '"]').addClass(vm.activeContentClass);

                // second iteration (smaller tabs, if exists)
            }  else if (index === 1) {
                let panelId = tabIds[0] + '-' + value;
                vm.$plugin.find('[data-tncp-tabs-panel-lvl="' + index +  '"]').removeClass(vm.activePanelClass);
                vm.$plugin.find('[data-tncp-tabs-panel-lvl="' + index +  '"][data-tncp-tabs-panel-id="' + panelId +  '"]').addClass(vm.activePanelClass);

                vm.$plugin.find('[data-tncp-tabs-content-lvl="' + index +  '"]').removeClass(vm.activeContentClass);
                vm.$plugin.find('[data-tncp-tabs-content-lvl="' + index +  '"][data-tncp-tabs-content-id="' + panelId +  '"]').addClass(vm.activeContentClass);

            }
        });
    }
}

